import { useEffect, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Toolbar from '@mui/material/Toolbar';

// project-imports
import Search from './Search';
import Profile from './Profile';
import Localization from './Localization';
import IconButton from 'components/@extended/IconButton';
import Transitions from 'components/@extended/Transitions';
import { ThemeMode } from 'config';

// assets
import { MoreSquare } from 'iconsax-react';

// ==============================|| HEADER CONTENT - MOBILE ||============================== //

export default function MobileSection() {
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const anchorRef = useRef<any>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const iconBackColorOpen = theme.palette.mode === ThemeMode.DARK ? 'background.paper' : 'secondary.200';
  const iconBackColor = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'secondary.100';

  return (
      <>
        <Box sx={{ flexShrink: 0, ml: 0.75 }}>
          <IconButton
              aria-label="open more menu"
              ref={anchorRef}
              aria-controls={open ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
              color="secondary"
              variant="light"
              size="large"
              sx={{
                color: 'secondary.main',
                bgcolor: open ? iconBackColorOpen : iconBackColor,
                p: 1
              }}
          >
            <MoreSquare variant="Bulk" style={{ transform: 'rotate(90deg)' }} />
          </IconButton>
        </Box>
        <Popper
            placement="bottom-end"
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            sx={{ width: '100%' }}
            popperOptions={{ modifiers: [{ name: 'offset', options: { offset: [0, 9] } }] }}
        >
          {({ TransitionProps }) => (
              <Transitions type="fade" in={open} {...TransitionProps}>
                <Paper sx={{ boxShadow: theme.customShadows.z1 }}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <AppBar color="inherit" elevation={0}>
                      <Toolbar
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 2,
                            flexWrap: 'wrap'
                          }}
                      >
                        {/*<Search />*/}
                        <Localization />
                        <Profile />
                      </Toolbar>
                    </AppBar>
                  </ClickAwayListener>
                </Paper>
              </Transitions>
          )}
        </Popper>
      </>
  );
}
